// extracted by mini-css-extract-plugin
export default {"root":"PurchaseAdviceFeeDialog_root__MbsHq"};